import Axios from "axios";
import {
  SET_LC_IMPORT_LC_MASTER_LIST,
  UNSET_LC_IMPORT_LC_MASTER_LIST,
  SET_EDITING_LC_IMPORT_LC_MASTER,
  UNSET_EDITING_LC_IMPORT_LC_MASTER,
} from "@/store/mutation-types";
import {
  saveUpdateLcImportLcMaster,
  getLcImportLcMasterList,
  getLcImportLcMasterById as getLcImportLcMasterByIdApi,
} from "@/store/api";

// initial state
const state = {
  lcImportLcMasterList: [],
  editingLcImportLcMaster: null,
};

const getters = {
  getLcImportLcMasterList(state) {
    return state.lcImportLcMasterList;
  },
  getEditingLcImportLcMaster(state) {
    return state.editingLcImportLcMaster;
  },
};

const mutations = {
  [SET_LC_IMPORT_LC_MASTER_LIST](state, data) {
    state.lcImportLcMasterList = data;
  },
  [UNSET_LC_IMPORT_LC_MASTER_LIST](state) {
    state.lcImportLcMasterList = [];
  },
  [SET_EDITING_LC_IMPORT_LC_MASTER](state, data) {
    state.editingLcImportLcMaster = data;
  },
  [UNSET_EDITING_LC_IMPORT_LC_MASTER](state) {
    state.editingLcImportLcMaster = null;
  },
};

const actions = {
  saveUpdateLcImportLcMaster({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcImportLcMaster, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcImportLcMasterList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcImportLcMasterList)
        .then(function (response) {
          commit(SET_LC_IMPORT_LC_MASTER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch(function (error) {
          commit(UNSET_LC_IMPORT_LC_MASTER_LIST);
          reject(error);
        });
    });
  },

  getLcImportLcMasterById({ commit }, id) {
    const url = `${getLcImportLcMasterByIdApi}${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          commit(SET_EDITING_LC_IMPORT_LC_MASTER, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

